module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-e75c1dcd85f848cc319347afcd7a74a4.png";